import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import bannerImage from '@/assets/images/banner.jpg';
import servicesBannerImage from '@/assets/images/computer_walletpaper.png';
import BannerCarousel, { type BannerSlide } from '../components/BannerCarousel';
import './HomePage.css';

const HomePage: React.FC = () => {
  const { t } = useTranslation();

  const bannerSlides: readonly BannerSlide[] = [
    {
      id: 'installment-offer',
      imageSrc: bannerImage,
      imageAlt: t('home.installment_banner_alt'),
    },
    {
      id: 'store-services',
      imageSrc: servicesBannerImage,
      imageAlt: t('home.services_banner_alt'),
      fit: 'contain',
    },
  ];

  return (
    <div className="home-page">
      <BannerCarousel slides={bannerSlides} />

      {/* Featured Categories */}
      <section className="categories">
        <h2>Danh Mục Sản Phẩm</h2>
        <div className="category-grid">
          <Link to="/products?category=iphone" className="category-card">
            <div className="category-icon">🍎</div>
            <h3>iPhone</h3>
            <p>Cao cấp, sang trọng</p>
          </Link>
          <Link to="/products?category=samsung" className="category-card">
            <div className="category-icon">📱</div>
            <h3>Samsung</h3>
            <p>Đa dạng, hiện đại</p>
          </Link>
          <Link to="/products?category=xiaomi" className="category-card">
            <div className="category-icon">⚡</div>
            <h3>Xiaomi</h3>
            <p>Giá tốt, chất lượng</p>
          </Link>
          <Link to="/products?category=oppo" className="category-card">
            <div className="category-icon">✨</div>
            <h3>OPPO</h3>
            <p>Camera đỉnh cao</p>
          </Link>
        </div>
      </section>

      {/* Hot Deals */}
      <section className="hot-deals">
        <h2>🔥 Khuyến Mãi Hot</h2>
        <div className="deal-grid">
          <div className="deal-card">
            <div className="deal-badge">-30%</div>
            <h3>iPhone 15 Pro Max</h3>
            <p className="old-price">30.990.000đ</p>
            <p className="new-price">21.690.000đ</p>
            <button className="buy-button">Mua ngay</button>
          </div>
          <div className="deal-card">
            <div className="deal-badge">-25%</div>
            <h3>Samsung S24 Ultra</h3>
            <p className="old-price">27.990.000đ</p>
            <p className="new-price">20.990.000đ</p>
            <button className="buy-button">Mua ngay</button>
          </div>
          <div className="deal-card">
            <div className="deal-badge">-20%</div>
            <h3>Xiaomi 14 Pro</h3>
            <p className="old-price">15.990.000đ</p>
            <p className="new-price">12.790.000đ</p>
            <button className="buy-button">Mua ngay</button>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us">
        <h2>Tại Sao Chọn Chúng Tôi?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">✅</div>
            <h3>Chính Hãng 100%</h3>
            <p>Cam kết sản phẩm chính hãng, có tem phiếu đầy đủ</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🚚</div>
            <h3>Giao Hàng Nhanh</h3>
            <p>Giao hàng toàn quốc trong 24h</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔧</div>
            <h3>Bảo Hành Uy Tín</h3>
            <p>Bảo hành 12 tháng, đổi mới trong 30 ngày</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💰</div>
            <h3>Giá Tốt Nhất</h3>
            <p>Cam kết giá tốt nhất thị trường</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
